module.exports = __webpack_public_path__ + "static/media/0_2019_10_19.04bfa5b1.jpg";